import api from "../../../components/axiosComp";

// SEND notification
export const sendAdminNotification = async (payload) => {
  const { data } = await api.post("/api/admin/notifications/send", payload);
  return data; // { success, message, meta? }
};

// LIST recent notifications
export const listAdminNotifications = async (params = {}) => {
  const { data } = await api.get("/api/admin/notifications/list", {
    params,
  });

  // backend returns: { success, data: [...], pagination: {...} }
  return {
    items: Array.isArray(data?.data) ? data.data : [],
    pagination: data?.pagination || {},
  };
};

// META for dropdowns (types, targets, users, roles)
export const getNotificationsMeta = async () => {
  const { data } = await api.get("/api/admin/notifications/meta");
  // Pass through as-is; caller will handle defaults
  return data || {};
};
